import { Modal } from "antd";
import React from "react";
import ErrorPage from "../Notification/Error";

function Rating({ props }) {
  const {
    isModal,
    onSubmit,
    onCancel,
    element,
    onChange,
    rate,
    isError,
    loadingRate,
  } = props;

  return (
    <Modal
      title={null}
      visible={isModal}
      onOk={null}
      onCancel={null}
      footer={null}
      closable={false}
      keyboard={false}
      width={400}
    >
      <div>
        <p className="colors-blue text-2xl mb-3 font-bold">Penilaian Layanan</p>
        <p className="colors-gray text-base mb-8 w-full">
          Demi meningkatkan layanan, Anda bisa memberikan penilaian kepada kami
        </p>
        {/* Star Section */}
        <div>
          <div className="mb-6">
            <div className="mb-2 flex items-center justify-center">
              {element.map((it, index) => (
                <img
                  key={index}
                  onClick={() => onChange("rating", it)}
                  src={
                    process.env.REACT_APP_BASE_URL +
                    `/assets/icon/${
                      it <= rate.rating
                        ? "ic_rate_ready.svg"
                        : "ic_rate_non.svg"
                    }`
                  }
                  alt="icon-star"
                  className="mx-2 cursor-pointer"
                />
              ))}
            </div>
            {isError
              ? isError.length > 0
                ? isError
                    .filter((it) => it.type === "rating")
                    .map((its, idx) => (
                      <ErrorPage
                        key={idx}
                        props={{ idx, message: its.message }}
                      />
                    ))
                : null
              : null}
          </div>
          <div className="mb-5">
            <div name="catatan-form" className="mt-5">
              <p className="login-title-form mb-2 text-lg">Komentar</p>
              <textarea
                onChange={(e) => onChange("description", e.target.value)}
                value={rate.description}
                name="description"
                className="form-input outline-none w-full p-3"
                placeholder="Masukkan komentar anda"
                rows="4"
              />
              {isError
                ? isError.length > 0
                  ? isError
                      .filter((it) => it.type === "description")
                      .map((its, idx) => (
                        <ErrorPage
                          key={idx}
                          props={{ idx, message: its.message }}
                        />
                      ))
                  : null
                : null}
            </div>
          </div>
        </div>
        <div>
          <button
            disabled={loadingRate}
            onClick={onSubmit}
            className={`${
              loadingRate ? "btn-loading" : "btn-blue"
            }  w-full p-3 mt-8 focus:outline-none`}
          >
            <p className="text-white lg:text-lg">
              {loadingRate ? "Loading" : "Kirim Penilaian"}
            </p>
          </button>
          <p
            onClick={onCancel}
            disabled={loadingRate}
            className="text-center mt-5 cursor-pointer colors-gray font-semibold text-base"
          >
            Batal
          </p>
        </div>
      </div>
    </Modal>
  );
}

export default Rating;
